import { useContext } from 'react';

import {
  NavLinkState,
  UNSAFE_DataRouterStateContext,
  UNSAFE_NavigationContext,
  useLocation,
  UseNavLinkProps,
  useResolvedPath,
} from '@spazious/dollhouse-router';

/**
 * @see https://github.com/remix-run/react-router/blob/main/packages/react-router-dom/index.tsx
 */
export const useNavLinkState = (props: UseNavLinkProps): NavLinkState => {
  const { end = false, to, relative } = props;
  const navigationState = useContext(UNSAFE_NavigationContext);
  if (!navigationState) {
    throw new Error('You should not use useNavLinkState outside a Router');
  }
  const routerState = useContext(UNSAFE_DataRouterStateContext);
  if (!routerState) {
    throw new Error('You should not use useNavLinkState outside a DataRouter');
  }
  const path = useResolvedPath(to, { relative });
  const location = useLocation();
  const { navigator } = navigationState;
  const nextLocationPathname =
    routerState && routerState.navigation && routerState.navigation.location
      ? routerState.navigation.location.pathname
      : null;
  const locationPathname = location.pathname;
  const toPathname = navigator.encodeLocation
    ? navigator.encodeLocation(path).pathname
    : path.pathname;

  const isActive =
    locationPathname === toPathname ||
    (!end &&
      locationPathname.startsWith(toPathname) &&
      locationPathname.charAt(toPathname.length) === '/');

  const isPending =
    nextLocationPathname != null &&
    (nextLocationPathname === toPathname ||
      (!end &&
        nextLocationPathname.startsWith(toPathname) &&
        nextLocationPathname.charAt(toPathname.length) === '/'));

  return {
    actived: isActive,
    pending: isPending,
  };
};

export default useNavLinkState;
